import { render, staticRenderFns } from "./apisectiongroupform.vue?vue&type=template&id=f00661e0&"
import script from "./apisectiongroupform.vue?vue&type=script&lang=js&"
export * from "./apisectiongroupform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports